/**
 * Page manager screen watchers helpers
 * @module services/pm-screen/watchers
 */
import { Map } from 'immutable'
import { getUserLanguagePrimary } from 'services/user'
import {
  GET_MULTIPLE_PM_SECTIONS,
  GET_PM_SECTION,
} from './actions'
import { getPmSectionMultiple, getPmSectionSingle } from './watchers-helpers'

export function onGetMultiplePmSections ({ after }) {
  return after(GET_MULTIPLE_PM_SECTIONS, async ({ dispatch, state, action }) => {
    const {
      auth = Map(),
      resolver = Map(),
      pmSection = Map(),
      user = Map(),
    } = state
    const {
      payload: {
        sectionIds,
        limit,
        language = getUserLanguagePrimary(user),
      } = {},
    } = action

    await getPmSectionMultiple({
      dispatch,
      language,
      auth,
      resolver,
      pmSection,
      sectionIds,
      limit,
    })
  })
}

export function onGetPmSection ({ after }) {
  return after(GET_PM_SECTION, async ({ dispatch, state, action }) => {
    const {
      auth = Map(),
      pmSection = Map(),
      user = Map(),
      resolver = Map(),
    } = state
    const {
      payload: {
        sectionId,
        language = getUserLanguagePrimary(user),
      } = {},
    } = action

    await getPmSectionSingle({
      dispatch,
      language,
      auth,
      resolver,
      pmSection,
      sectionId,
    })
  })
}
